const YEAR_FORMS = ['год', 'года', 'лет'];

/** Russian plural form of "год" for a number of years (1 год, 2 года, 5 лет). */
export const getYearsText = (years: number): string => {
  const lastTwo = years % 100;
  const last = years % 10;
  if (lastTwo >= 11 && lastTwo <= 14) return YEAR_FORMS[2];
  if (last === 1) return YEAR_FORMS[0];
  if (last >= 2 && last <= 4) return YEAR_FORMS[1];
  return YEAR_FORMS[2];
};
